import React, { Component } from "react";
import { fetchJobSummaryCnt, fetchChartCount, fetchWeeklyChartCount} from "../ApiSevices/DashboardApis";
import BarChart from "../Dashboard/BarChart";
import LineChart from "../Dashboard/LineChart";
import { GridTable } from "../Sidebar/SidebarStyles";
import JobSummary from "./JobSummary";
import { Box } from "@mui/material";
import { expTokenProcessAndGenerate } from "../ApiSevices/AuthApis";

const token = sessionStorage.getItem('token');
interface DashboardUIState {
    summaryCountData: any;
    barChartCountData: { categories: string[]; series: { name: string; data: number[]; color: string }[] } | null;
    lineChartCountData: { categories: string[]; series: { name: string; data: number[]; color: string }[] } | null;
    loading: boolean;
}

interface TableProps {
    displaysidebar: boolean;
}

class DashboardUI extends Component<TableProps, DashboardUIState> {
    constructor(props: TableProps) {
        super(props);
        this.state = {
            summaryCountData: null,
            barChartCountData: null,
            lineChartCountData: null,
            loading: false,
        };
    }

    componentDidMount() {
        this.fetchCount();
        this.dashboardCountFetch();
    }

    fetchCount = async () => {
        this.setState({ loading: true });

        try {
            const data = await fetchJobSummaryCnt(token);
            
            type StatusCategories = {
                [key: string]: number[];
            };
            
            type SubStatusItem = { 
                statusId: number; 
                statusName: string; 
                jobCount: number,
                Status_id: number 
            };

            const statusCategories: StatusCategories = {
                InProgress: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
                    12, 13, 14, 15, 16, 17, 28
                ],
                Success: [18, 19, 20, 21, 22, 23, 24, 25],
                Dispatch: [26],
                Dispatch_Failed: [27, 29]
            };

            const jobTypeCounts = data?.JobTypeCounts.reduce(
                (acc: Record<string, number>, type: { JobType: string; JobCount: number }) => {
                    acc[type.JobType] = type.JobCount;
                    return acc;
                }, 
                {} as Record<string, number>
            );

            const jobStatusCounts = data?.JobStatusCounts.reduce(
                (acc: Record<string, SubStatusItem[]>, status: { Id: number; Status: string; JobCount: number; Status_id: number; category: number }) => {
                    Object.entries(statusCategories)?.forEach(([state, ids]) => {
                        if (ids.includes(status.Id)) {
                            if (!acc[state]) acc[state] = [];
                            acc[state].push({
                                statusId: status.Id,
                                statusName: status.Status,
                                jobCount: status.JobCount,
                                Status_id: status.category  
                            });
                        }
                    });
                    return acc;
                },
                {} as Record<string, SubStatusItem[]>
            );

            const totalCount = (Object.values(jobTypeCounts) as number[]).reduce(
                (sum, count) => sum + count, 
                0
            );
            
            this.setState({ 
                summaryCountData: {
                    totalCount,
                    jobTypeCounts,
                    jobStatusCounts
                },
                loading: false 
            });
        } catch (error) {
            console.error('Error fetching count:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    dashboardCountFetch = async () => {
        this.setState({ loading: true });

        try {
            // Fetch both weekly and monthly data
            const weeklyChartData = await fetchWeeklyChartCount(token);
            const monthlyChartData = await fetchChartCount(token);      

            if (weeklyChartData?.data && monthlyChartData?.data) {
                const colors = {
                    "InProgress Jobs": "#007bff", //Blue
                    "Success Jobs": "#28a745", //Green
                    "Dispatch Jobs": "#808080", //Gray
                    "Dispatch Failed Jobs": "#dc3545", //Red
                };

                // Weekly data for Bar Chart
                const weeklyFormatted = {
                    categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
                    series: weeklyChartData.data.map((item: any) => ({
                        name: item.name,
                        data: item.data,
                        color: colors[item.name as keyof typeof colors] || "#000",
                    })),
                };



                // Monthly data for Line Chart
                const monthlyFormatted = {
                    categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                    series: monthlyChartData.data.map((item: any) => ({
                        name: item.name,
                        data: item.data,
                        color: colors[item.name as keyof typeof colors] || "#000",
                    })),
                };

                // Update both charts
                this.setState({
                    barChartCountData: weeklyFormatted,
                    lineChartCountData: monthlyFormatted,
                    loading: false,
                });
            }
        } catch (error) {
            console.error("Error fetching chart data:", error);
        } finally {
            this.setState({ loading: false });
        }
    };


    render() {
        const { summaryCountData, barChartCountData, lineChartCountData, loading } = this.state;
        const { displaysidebar } = this?.props;

        return (
            <>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div> 
                    </Box>
                )}

                <GridTable displaysidebar={displaysidebar}>
                    <Box sx={{ maxHeight: "80vh", overflowY: "auto", padding: "10px" }}>
                        <div>
                            {/* Job Summary Section */}
                            <div style={{ display: 'flex', marginBottom: '20px' }}>
                                <JobSummary summaryCountData={summaryCountData} />
                            </div>

                            {/* Bar Chart Section */}
                            <div style={{ marginBottom: '30px' }}>
                                <h2 style={{ fontWeight: "bold", fontSize: '15px' }}>Jobs Summary Bar Chart</h2>
                                {/* <hr style={{ borderTop: "2px solid blue"}} /> */}
                                {/* <h3>Bar Chart</h3> */}
                                {/* <hr style={{ borderTop: "2px solid blue", width: "10%" }} /> */}
                                <BarChart barChartCountData={barChartCountData} loading={loading} />
                            </div>

                            {/* Line Chart Section */}
                            <div>
                                <h2 style={{ fontWeight: "bold", fontSize: '15px' }}>Jobs Summary Line Chart</h2>
                                {/* <hr style={{ borderTop: "2px solid blue", width: "20%" }} /> */}
                                {/* <h3>Line Chart</h3> */}
                                {/* <hr style={{ borderTop: "2px solid blue", width: "10%" }} /> */}
                                <LineChart lineChartCountData={lineChartCountData} loading={loading} />
                            </div>
                        </div>
                    </Box>
                </GridTable>
            </>
        );
    }
}

export default DashboardUI;
